import { SVGProps } from 'react';

const Paperclip = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m16 6-8.414 8.586a2 2 0 1 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a5.999 5.999 0 1 0 8.485 8.485l8.379-8.551"
    />
  </svg>
);
export default Paperclip;
